'use client'

import {useState} from 'react'
import ContactUsForm from './contact/ContactUsForm'

export default function ChatContactWidget() {
  const [open, setOpen] = useState(false)

  return (
    <>
      {/* Floating Button */}
      <button onClick={() => setOpen(!open)} style={styles.fab} aria-label="Contact us">
        💬
      </button>

      {/* Chat Panel */}
      {open && (
        <div style={styles.panel}>
          <div style={styles.header}>
            <span>Contact Us</span>
            <button onClick={() => setOpen(false)} style={styles.close}>
              ✕
            </button>
          </div>

          <h2 className="px-auto py-3 w-full text-center">Send us your ticket</h2>
          <ContactUsForm withTitle={false} />
        </div>
      )}
    </>
  )
}
const styles: Record<string, React.CSSProperties> = {
  fab: {
    position: 'fixed',
    bottom: 20,
    right: 20,
    width: 56,
    height: 56,
    borderRadius: '50%',
    border: 'none',
    background: 'rgb(231 0 11)',
    color: '#fff',
    fontSize: 24,
    cursor: 'pointer',
    boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
    zIndex: 1000,
  },
  panel: {
    position: 'fixed',
    bottom: 90,
    right: 20,
    width: 320,
    background: '#fff',
    borderRadius: 12,
    boxShadow: '0 16px 40px rgba(0,0,0,0.2)',
    overflow: 'hidden',
    fontFamily: 'system-ui',
    zIndex: 1000,
  },
  header: {
    padding: '12px 16px',
    background: 'rgb(231 0 11)',
    color: '#fff',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  close: {
    background: 'transparent',
    border: 'none',
    color: '#fff',
    fontSize: 18,
    cursor: 'pointer',
  },
  form: {
    padding: 16,
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
  },
}
